'use client'
import Footer from '@/app/components/organisms/Footer'
import Header from '@/app/components/organisms/Header'
import { IBM_Plex_Mono, PT_Serif, Krona_One, Poppins } from 'next/font/google'
import Circle from '../atoms/Circle'

const mono = IBM_Plex_Mono({
  variable: '--font-family-mono',
  subsets: ['latin'],
  weight: ['500', '700'],
  display: 'swap',
})

const sans = Poppins({
  variable: '--font-family-sans',
  subsets: ['latin'],
  weight: ['200', '300', '400', '500', '700', '800'],
  display: 'swap',
})

const serif = PT_Serif({
  variable: '--font-family-serif',
  style: ['normal', 'italic'],
  subsets: ['latin'],
  weight: ['400', '700'],
  display: 'swap',
})

const krona = Krona_One({
  variable: '--font-family-krona',
  subsets: ['latin'],
  weight: ['400'],
  display: 'swap',
})

/**
 *
 * @returns: En container, der indeholder header, footer og børnekomponenter.
 * @example: <PageContainer />
 * @alias: PageContainer
 * @module: components/PageContainer
 * @summary: Denne komponent bruges til at vise en container, der indeholder header, footer og børnekomponenter.
 * @see: src/components/PageContainer.tsx
 * @version: 1.0.0
 * @property: [children]
 * @author: Kasper Buchholtz
 *
 **/

export default function PageContainer({
  children,
  isFirstPageTitle,
}: {
  children: React.ReactNode
  isFirstPageTitle?: any
}) {
  return (
    <>
      <style jsx global>
        {`
          :root {
            --font-family-sans: ${sans.style.fontFamily};
            --font-family-serif: ${serif.style.fontFamily};
            --font-family-mono: ${mono.style.fontFamily};
            --font-family-krona: ${krona.style.fontFamily};
          }
        `}
      </style>
      <Header isFirstPageTitle={isFirstPageTitle} />
      <main
        className={`${sans.className} overflow-hidden min-h-screen bg-light-light`}
      >
        {children}
      </main>
      <Footer />
    </>
  )
}
